function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Row, Col, UncontrolledCollapse } from 'reactstrap';
import Icon from "../../../../../common/icon";
import ResponseBuilder from "./response";
import { _translate } from "../../../../../../services/core";
import { useWorkFlow } from "../../../../../contexts/workflow";
var Categorized = function Categorized(props) {
  var onChange = props.onChange,
    elements = props.elements,
    className = props.className,
    onClose = props.onClose;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    toogleOpen = _useState2[0],
    setToogleOpen = _useState2[1];
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentQuestion = collector.currentQuestion,
    currentOrder = collector.currentOrder;
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    responsesCategorized = _useState4[0],
    setResponsesCategorized = _useState4[1];
  var tagOnchange = function tagOnchange(response, checked, event, index) {
    event.stopPropagation();
    var arrayOrder = currentOrder.split('.');
    arrayOrder.pop();
    if (currentQuestion.loop) {
      arrayOrder.pop();
    }
    onChange(response, !checked, null, 'sequences' + arrayOrder.join('_'), index);
  };
  var _organizedCategories = function organizedCategories(categories, list, recursion) {
    var excluded = [];
    var newList = _objectSpread({}, list);

    // on parcours la liste de catégories [c1, c2, c3, etc...]
    // On créé si pas de parent les 1ers éléments.
    categories.forEach(function (category) {
      if (!category.parent) {
        newList[category.name] = {};
      } else if (category.parent && !newList[category.parent.name]) {
        excluded.push(category);
      } else {
        newList[category.parent.name][category.name] = {};
      }
    });

    // Les élements éxclus sont ceux dont le parent n'a pas été trouvé.
    if (excluded.length > 0 && recursion < 30) {
      Object.keys(newList).forEach(function (key) {
        newList[key] = _objectSpread(_objectSpread({}, newList[key]), _organizedCategories(excluded, newList[key], recursion + 1));
      });
    }
    return newList;
  };
  var verifyExistingValue = function verifyExistingValue(response, objectList) {
    var exist = false;
    Object.keys(objectList).forEach(function (element) {
      if (parseInt(element) && (objectList[element].id === response.id || objectList[element].alias === response.alias)) {
        exist = true;
      }
    });
    return exist;
  };
  var _insertResponseInsideCategory = function insertResponseInsideCategory(response, category, list) {
    var keys = Object.keys(list);
    keys.forEach(function (categoryList) {
      // C'est bien une catégorie

      if (!parseInt(categoryList)) {
        var categoryListElements = list[categoryList]; // {c1: {}, c2: {}, 1: {}, 2:{}}
        var _keys = Object.keys(categoryListElements); // [c1, c2, 1, 2]

        if (category.name === categoryList) {
          if (!verifyExistingValue(response, categoryListElements)) {
            categoryListElements[_keys.length + 1] = response;
          }
        } else {
          _insertResponseInsideCategory(response, category, categoryListElements);
        }
      }
    });
  };
  var clickCollapse = function clickCollapse(e, key) {
    e.preventDefault();
    var isOpen2 = toogleOpen[key];
    setToogleOpen(_objectSpread(_objectSpread({}, toogleOpen), {}, _defineProperty({}, key, !isOpen2)));
  };
  var _buildMenu = function buildMenu(elements) {
    var tabulation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Object.keys(elements).map(function (key, index) {
      var objectKey = "collapser_".concat(key[0]).concat(key[key.length - 1], "_").concat(index, "_").concat(tabulation);
      var isOpen = toogleOpen[objectKey];
      var isSmallSize = tabulation > 0;

      // catégorie
      if (!parseInt(key)) {
        return /*#__PURE__*/React.createElement("div", {
          key: objectKey,
          className: "pl-".concat(tabulation, " ").concat(isSmallSize ? 'small-size' : '')
        }, /*#__PURE__*/React.createElement(Row, {
          id: objectKey,
          className: "categorized-line parent ".concat(isOpen ? 'active' : ''),
          onClick: function onClick(e) {
            return clickCollapse(e, objectKey);
          }
        }, /*#__PURE__*/React.createElement(Col, {
          className: "col-auto d-flex justify-content-start align-items-center"
        }, /*#__PURE__*/React.createElement("span", {
          className: "label"
        }, _translate(key))), /*#__PURE__*/React.createElement(Col, {
          className: "d-flex justify-content-end align-items-center"
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "icon-categorized ml-2",
          name: "caret-".concat(isOpen ? 'down' : 'right')
        }))), /*#__PURE__*/React.createElement(UncontrolledCollapse, {
          toggler: objectKey
        }, _buildMenu(elements[key], tabulation + 1)));
      } else {
        // reponse
        return /*#__PURE__*/React.createElement(ResponseBuilder, {
          response: elements[key],
          tabulation: tabulation,
          onChange: tagOnchange
        });
      }
    });
  };
  useEffect(function () {
    if (!currentQuestion.categories) {
      return;
    }

    // maintenant que j'ai organisé mes catégories
    var list = _organizedCategories(currentQuestion.categories, {}, 0);
    // je dois ranger mes élements à l'intérieur.

    elements.forEach(function (response) {
      // Pour chaque catégories de la réponse nous allons inséré la réponse dans la liste (si trouvée)
      if (Array.isArray(response.categories)) {
        response.categories.forEach(function (category) {
          _insertResponseInsideCategory(response, category, list);
        });
      }
    });
    setResponsesCategorized(list);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "background-".concat(className),
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Row, {
    className: "w-100 ".concat(className)
  }, responsesCategorized && /*#__PURE__*/React.createElement("div", {
    className: "list"
  }, _buildMenu(responsesCategorized))));
};
Categorized.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
Categorized.defaultProps = {
  elements: [],
  responses: {}
};
export default Categorized;